import React from "react";
import { CartItem as CartItemType } from "@/shared/types";
import "./styles/CartItem.scss";
import { formatPhotoUrl } from "../utils/formatter";
import { ProductLineTotal } from "./ProductPriceDisplay";
import {
  formatUnitPriceLabel,
  getQuantityUnit,
} from "../utils/productPricing";

interface CartItemProps {
  item: CartItemType;
  onUpdateQuantity: (productId: string, quantity: number) => void;
  onRemove: (productId: string) => void;
}

export const CartItem: React.FC<CartItemProps> = ({
  item,
  onUpdateQuantity,
  onRemove,
}) => {
  const { product, quantity } = item;
  const unit = getQuantityUnit(product);

  const handleIncrement = () => {
    onUpdateQuantity(product.id, quantity + 1);
  };

  const handleDecrement = () => {
    if (quantity === 1) {
      onRemove(product.id);
    } else {
      onUpdateQuantity(product.id, quantity - 1);
    }
  };

  const hasPhoto = product.photo && product.photo.trim() !== "";
  const imageUrl = formatPhotoUrl(product.photo);

  return (
    <div className="cart-item">
      <div className="cart-item__image">
        {hasPhoto ? (
          <img src={imageUrl} alt={product.name} loading="lazy" />
        ) : (
          <div className="cart-item__no-image">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <polyline points="21 15 16 10 5 21"></polyline>
            </svg>
          </div>
        )}
      </div>

      <div className="cart-item__content">
        <div className="cart-item__header">
          <h3 className="cart-item__title">{product.name}</h3>
          <button 
            className="cart-item__remove"
            onClick={() => onRemove(product.id)}
            aria-label="Удалить товар"
          >
            ×
          </button>
        </div>

        {product.description && (
          <div className="cart-item__description">
            <span className="cart-item__article">Артикул: {product.article || product.outcode}</span>
          </div>
        )}

        <div className="cart-item__quantity-block">
          <div className="cart-item__quantity">
            <button 
              className="cart-item__quantity-btn"
              onClick={handleDecrement}
              aria-label="Уменьшить количество"
            >
              −
            </button>
            <span className="cart-item__quantity-value">
              {quantity} {unit}
            </span>
            <button 
              className="cart-item__quantity-btn"
              onClick={handleIncrement}
              aria-label="Увеличить количество"
            >
              +
            </button>
          </div>
          
          <div className="cart-item__price-info">
            <span className="cart-item__unit-price">
              {formatUnitPriceLabel(product, quantity)}
            </span>
            <ProductLineTotal
              product={product}
              quantity={quantity}
              className="cart-item__total"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
